// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartitionSpecInput } from './PartitionSpecInput';
import {
  PartitionSpecInputFromJSON,
  PartitionSpecInputFromJSONTyped,
  PartitionSpecInputToJSON,
  PartitionSpecInputToJSONTyped,
} from './PartitionSpecInput';
import type { MetadataInput } from './MetadataInput';
import {
  MetadataInputFromJSON,
  MetadataInputFromJSONTyped,
  MetadataInputToJSON,
  MetadataInputToJSONTyped,
} from './MetadataInput';

/**
 *
 * @export
 * @interface CreatePartition
 */
export interface CreatePartition {
  /**
   *
   * @type {MetadataInput}
   * @memberof CreatePartition
   */
  metadata?: MetadataInput;
  /**
   *
   * @type {PartitionSpecInput}
   * @memberof CreatePartition
   */
  spec?: PartitionSpecInput;
}

/**
 * Check if a given object implements the CreatePartition interface.
 */
export function instanceOfCreatePartition(
  value: object,
): value is CreatePartition {
  return true;
}

export function CreatePartitionFromJSON(json: any): CreatePartition {
  return CreatePartitionFromJSONTyped(json, false);
}

export function CreatePartitionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CreatePartition {
  if (json == null) {
    return json;
  }
  return {
    metadata:
      json['metadata'] == null
        ? undefined
        : MetadataInputFromJSON(json['metadata']),
    spec:
      json['spec'] == null
        ? undefined
        : PartitionSpecInputFromJSON(json['spec']),
  };
}

export function CreatePartitionToJSON(json: any): CreatePartition {
  return CreatePartitionToJSONTyped(json, false);
}

export function CreatePartitionToJSONTyped(
  value?: CreatePartition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    metadata: MetadataInputToJSON(value['metadata']),
    spec: PartitionSpecInputToJSON(value['spec']),
  };
}
